export default "__VITE_ASSET__CHhB2sxW__"